module.exports = __webpack_public_path__ + "img/1-6.06793dd1.png";